import * as service from './services'
import to from 'await-to-js'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async saveCartao ({dispatch}, payload) {
    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(service.saveCartao(payload))
    if (error) {
      dispatch('showErrorMsg', error)
      dispatch('setLoading', false)
      return Promise.reject(error)
    }
    dispatch('setLoading', false)
    return response.data
  },

  async getCartao ({dispatch}, id) {
    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(service.getCartao(id))
    if (error) {
      dispatch('showErrorMsg', error)
      dispatch('setLoading', false)
      return Promise.reject(error)
    }
    dispatch('setLoading', false)

    return response.data
  },

  async getSaude ({dispatch}, id) {
    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(service.getSaude(id))
    if (error) {
      dispatch('showErrorMsg', error)
      dispatch('setLoading', false)
      return Promise.reject(error)
    }
    dispatch('setLoading', false)

    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/cartaoSin/index.js